import { TableHeadProps, Thead } from '@chakra-ui/react';

interface CustomTheadProps extends TableHeadProps {
  children: React.ReactNode;
}

export default function CustomThead({ children, ...rest }: CustomTheadProps) {
  return (
    <Thead
      borderBottom="1px solid #EBEDEF"
      color="gray.300"
      textTransform="uppercase"
      {...rest}
    >
      {children}
    </Thead>
  );
}
